import router from './../../router'
export default {
  namespaced: true,
  state: {
    cache : [],
    user: window.localStorage.getItem('user') ? JSON.parse(window.localStorage.getItem('user')) : false
  },
  mutations: {
    logout: (state) => {
      window.localStorage.removeItem('user')
      state.user = false
      router.push('/sign-in')
    },
    setUser: (state, user) => {
      state.user = user
      window.localStorage.setItem('user', JSON.stringify(user))
    }
  },
  actions : {
    updateProfile(store,payload){
      return new Promise((resolve,reject) => {
        axios.put('user',payload).then((data) => {
          resolve(data);
        }).catch(e => reject(e));
      })
    },
    setUser(store,payload){
      return new Promise(resolve => {
        store.commit('setUser',payload);
        resolve();
      });
    }
  },
  getters: {
    getUser : (state) => {
      return state.user.data;
    },
    loggedIn (state) {
      return state.user
    },
    filled (state) {
      return !!state.user.name
    }
  }
}
